<template lang="pug">
div(:style="styles").page-timers
  div(
    v-for="(row, rowIndex) in vList"
    :key="rowIndex"
  ).page-timer-row
    PageTimer(
      v-for="(item, index) in row"
      :key="`${rowIndex}-${index}`"
      v-bind="item"
      :activeInGroup="active.includes(`${rowIndex}-${index}`)"
      :keyInGroup="`${rowIndex}-${index}`"
      @start="handleStart"
      :theme="theme"
    ).page-timer-item
</template>

<script>
import _ from 'lodash'
import PageTimer from './PageTimer.vue'

export default {
  name: 'PageTimers',
  props: {
    list: { type: Array, default: () => [] },
    mode: { type: String, default: 'single' }, // single, parallel
    theme: { type: String, default: 'primary' }, // primary, lite
    rowSize: { type: Number, default: 2 },
    styles: { type: Object, default: () => ({}) },
    keyCodeStartAt: { type: Number, default: 1 },
  },
  components: {
    PageTimer,
  },
  data() {
    return {
      active: [],
    }
  },
  computed: {
    vList() {
      return _.chunk(_.map(this.list, this.formatTimer), this.rowSize)
    },
  },
  watch: {
    mode() {
      this.updateActive()
    },
  },
  mounted() {
    this.updateActive()
  },
  methods: {
    updateActive() {
      if (this.mode === 'parallel') {
        this.active = _.keys(this.list)
      } else if (this.active.length !== 1) {
        this.active = [_.keys(this.list)[0]]
      }
    },
    formatTimer(res, index) {
      const ret = {
        mode: 'timer',
        title: '',
        duration: '03:00',
        format: 'mm:ss:SSS',
        highlightAt: null,
        highlightColor: 'red',
        blinkAt: null,
        allowOverdue: true,
        bells: [],
        keyCode: index + this.keyCodeStartAt,
        ...res,
      }
      return ret
    },
    handleStart(keyInGroup) {
      if (this.mode === 'single') {
        this.active = [keyInGroup]
      }
      this.updateActive()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-ui-flex';

.page-timers {
  @include ui-flex-col;
  flex-wrap: wrap;
}
.page-timer-row {
  margin: 0.2em 0.3em;
  @include ui-flex-row;
}
.page-timer-item {
  margin: 0 0.2em;
}
</style>
